export const Attachment = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1115 15.2372L14.1893 9.47617C15.2152 7.55582 15.8656 4.12095 12.3117 1.90352C8.75779 -0.3139 6.33042 2.01226 5.3045 3.93261L1.71377 10.6538C0.687841 12.5742 0.550394 15.0489 2.77158 16.4348C4.99278 17.8206 6.90718 16.4547 7.9331 14.5343L10.2414 10.2135C11.7803 7.33301 12.5498 5.89275 10.7728 4.78404C8.99585 3.67533 8.22641 5.11559 6.68752 7.99611L4.89216 11.3567"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}
